"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromocodeLogicValueDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const promocode_discount_product_type_logic_value_dto_1 = require("./promocode-discount-product-type-logic-value.dto");
class PromocodeLogicValueDto {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => promocode_discount_product_type_logic_value_dto_1.PromocodeDiscountProductTypeLogicValueDto),
    __metadata("design:type", promocode_discount_product_type_logic_value_dto_1.PromocodeDiscountProductTypeLogicValueDto)
], PromocodeLogicValueDto.prototype, "PERCENT_DISCOUNT_FOR_ALL_PRODUCT_TYPES", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PromocodeLogicValueDto.prototype, "PERCENT_DISCOUNT_FROM_SUBTOTAL", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PromocodeLogicValueDto.prototype, "FIXED_DISCOUNT_FROM_SUBTOTAL", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => promocode_discount_product_type_logic_value_dto_1.PromocodeDiscountProductTypeLogicValueDto),
    __metadata("design:type", promocode_discount_product_type_logic_value_dto_1.PromocodeDiscountProductTypeLogicValueDto)
], PromocodeLogicValueDto.prototype, "PERCENT_DISCOUNT_FOR_ONE_PRODUCT_TYPE", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PromocodeLogicValueDto.prototype, "FREE_SHIPPING", void 0);
exports.PromocodeLogicValueDto = PromocodeLogicValueDto;
//# sourceMappingURL=promocode-logic-value.dto.js.map